/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavMarketDataJob } from './DailyNavMarketDataJob';
export type DailyNavMarketDataReadiness = {
  /**
   * Whether the market data run covering snapshot_at has finished. pending blocks finalize and can pass on a later check; stalled is a run pending 15+ minutes past its scheduled time and passes with a warning (data in flight); failed passes with a warning (nothing more can land); unavailable blocks until it resolves; not_applicable has nothing to wait for.
   */
  status: DailyNavMarketDataReadiness.status;
  /**
   * The instant checked: the earliest of the market close, the Data Cutoff Time, and the finalize time (now, before finalize).
   */
  snapshot_at: string | null;
  /**
   * Latest estimated finish across pending runs; null when nothing is pending or no estimate exists. When to re-check.
   */
  expected_by: string | null;
  /**
   * When the last still-fresh pending run turns stalled, letting finalize pass; null when nothing fresh is pending.
   */
  stalls_at: string | null;
  jobs: Array<DailyNavMarketDataJob>;
};
export namespace DailyNavMarketDataReadiness {
  /**
   * Whether the market data run covering snapshot_at has finished. pending blocks finalize and can pass on a later check; stalled is a run pending 15+ minutes past its scheduled time and passes with a warning (data in flight); failed passes with a warning (nothing more can land); unavailable blocks until it resolves; not_applicable has nothing to wait for.
   */
  export enum status {
    COMPLETE = 'complete',
    PENDING = 'pending',
    STALLED = 'stalled',
    FAILED = 'failed',
    UNAVAILABLE = 'unavailable',
    NOT_APPLICABLE = 'not_applicable',
  }
}

